"use client";

import { useState, useEffect } from "react";
import { Sparkles, X } from "lucide-react";
import TravelChat from "./TravelChat";

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Prevent body scroll when chat is open on mobile
  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, isMobile]);

  return (
    <>
      {/* Chat Window */}
      {isOpen && (
        <>
          {/* Mobile: Full-screen overlay */}
          {isMobile ? (
            <div className="fixed inset-0 z-50 bg-white">
              <TravelChat onClose={() => setIsOpen(false)} />
            </div>
          ) : (
            /* Desktop: Floating window */
            <div className="fixed bottom-6 right-6 z-50 w-full max-w-sm">
              <div className="relative mb-20">
                <TravelChat />
              </div>
            </div>
          )}
        </>
      )}

      {/* Floating Button - Hidden on mobile when chat is open */}
      {(!isOpen || !isMobile) && (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 rounded-full p-3 sm:p-4 shadow-2xl transition-all duration-300 flex items-center gap-2 group touch-target ${
            isOpen
              ? "bg-gray-700 hover:bg-gray-600 text-white"
              : "bg-dirty-lime-200 hover:bg-dirty-lime-300 text-dirty-lime-800 ring-1 ring-dirty-lime-200/50 hover:scale-110"
          }`}
          aria-label={isOpen ? "Close chat" : "Open chat"}
        >
          {isOpen ? (
            <X className="w-5 h-5 sm:w-6 sm:h-6" />
          ) : (
            <>
              <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 transition-all duration-300 text-dirty-lime-800" />
            </>
          )}
        </button>
      )}
    </>
  );
}
